'use client';

import { createBrowserClient } from '@supabase/ssr';
import type { SupabaseClient } from '@supabase/supabase-js';
import {
  getSupabaseAnonKey,
  getSupabaseUrl,
  isSupabaseBrowserEnvConfigured,
} from '@/lib/supabase/env';

let client: SupabaseClient | null = null;

export function getSupabaseBrowserClient(): SupabaseClient | null {
  if (!isSupabaseBrowserEnvConfigured()) {
    return null;
  }

  if (client) {
    return client;
  }

  client = createBrowserClient(getSupabaseUrl(), getSupabaseAnonKey());
  return client;
}
